import React, { useState } from "react";
import "react-phone-input-2/lib/style.css";
import PhoneInput from "react-phone-input-2";
import "../css/Footer.css";
import Facebook from "../images/facebook.png"; 
import Insta from "../images/social.png"; 
import Twitter from "../images/twitter.png"; 
import Linkedin from "../images/linkedin.png"; 
import Google from "../images/google.png";

function Footer() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
  });

  const [errors, setErrors] = useState({});

  const validateForm = () => {
    const newErrors = {};

    if (!formData.name.trim()) {
      newErrors.name = "Name is required.";
    } else if (!/^[a-zA-Z ]+$/.test(formData.name)) {
      newErrors.name = "Name should contain only alphabets.";
    }

    if (!formData.email.trim()) {
      newErrors.email = "Email is required.";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = "Enter a valid email address.";
    }

    if (!formData.phone.trim()) {
      newErrors.phone = "Phone number is required.";
    }

    if (!formData.subject.trim()) {
      newErrors.subject = "Subject is required.";
    }

    if (!formData.message.trim()) {
      newErrors.message = "Message is required.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      alert("Message sent successfully!");
      setFormData({
        name: "",
        email: "",
        phone: "",
        subject: "",
        message: "",
      });
      setErrors({});
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  return (
    <div className="Footer">
      <div className="Footer-above">
        <form onSubmit={handleSubmit} className="contact-form">
          <div className="segment">
            <h1>Contact Us</h1>
          </div>

          {/* Name + Email row */}
          <div className="input-row">
            <label>
              <input
                type="text"
                name="name"
                placeholder="Name"
                value={formData.name}
                onChange={handleChange}
              />
              {errors.name && <span className="error">{errors.name}</span>}
            </label>
            <label>
              <input
                type="email"
                name="email"
                placeholder="Email Address"
                value={formData.email}
                onChange={handleChange}
              />
              {errors.email && <span className="error">{errors.email}</span>}
            </label>
          </div>

          {/* Phone input with country flags */}
          <div className="input-row">
            <PhoneInput
              country={"in"}
              value={formData.phone}
              onChange={(phone) => setFormData({ ...formData, phone })}
              inputClass="phone-input"
              enableSearch={true}
            />
            {errors.phone && <span className="error">{errors.phone}</span>}
          </div>

          <label>
            <input
              type="text"
              name="subject"
              placeholder="Subject/Interested in"
              value={formData.subject}
              onChange={handleChange}
            />
            {errors.subject && <span className="error">{errors.subject}</span>}
          </label>

          <label>
            <textarea
              name="message"
              placeholder="Write Message"
              value={formData.message}
              onChange={handleChange}
            ></textarea>
            {errors.message && <span className="error">{errors.message}</span>}
          </label>

          <button className="red" type="submit">
            Send Us Message
          </button>
        </form>
<div className="Footer-above-divider"> 
    <hr className="Footer-hr" /> 
    <p className="Footer-p">Or</p> 
    <hr className="Footer-hr" /> 
    </div> 
    <div className="Footer-above-options"> 
    <div className="Footer-above-option"> 
    <i 
    style={{ color: "blue", marginLeft: "20px", marginTop: "45px" }} 
    className="fa-brands fa-skype fa-2xl" 
    ></i> 
    <div className="Footer-option-info"> 
    <p className="Footer-p1" style={{ fontSize: "x-large" }}> 
    Our Skype ID 
    </p> 
    <p className="Footer-p1">PurohitTechnosoft</p> 
    </div> 
    </div> 
    <div className="Footer-above-option"> 
    <i
    style={{ color: "blue", marginLeft: "20px", marginTop: "45px" }} 
    className="fa-regular fa-envelope fa-2xl" ></i> 
    <div className="Footer-option-info"> 
    <p className="Footer-p1" style={{ fontSize: "x-large" }}> 
      Mail Us 
      </p> 
      <p className="Footer-
      p1">info@purohittechnosoft.com</p> 
      </div> 
      </div> 
      <div className="Footer-above-option"> 
        <i 
        style={{ color: "blue", marginLeft: "20px", marginTop: "45px" }} 
        className="fa-brands fa-whatsapp fa-2xl" 
        ></i> 
        <div className="Footer-option-info"> 
          <p className="Footer-p1" style={{ fontSize: "x-large" }}> 
          Whatsapp Us </p> 
          
           <a 
      href="https://wa.me/917891266745" 
      target="_blank" 
      rel="noopener noreferrer" 
      className="Footer-p1"
      style={{ color: "inherit", textDecoration: "none" }}
    >
      +91 7891266745
    </a>  
          </div> 
          </div> 
          </div> 
          </div> 
          <div className="Footer-below"> 
            <hr className="Footer-below-hr" /> 
            <div className="Footer-below-info"> 
            <p className="Footer-p2"> 
            Copyright ©2024{" "} 
            <span className="Footer-span">Purohit Technosoft Solutions</span> - 
            Powers you in IT World. All Rights Reserved. 
            </p> 
            <a 
            href="https://www.facebook.com/profile.php?id=61569999860273" target="_blank" 
            rel="noopener noreferrer" 
            > 
            <img 
            className="Footer-below-img" 
            src={Facebook} 
            alt="Facebook Profile" 
            />
            </a> 
            <img 
            style={{ marginLeft: "20px" }} 
            className="Footer-below-img" 
            src={Insta} 
            alt="" 
            /> 
            <img 
            style={{ marginLeft: "20px" }} 
            className="Footer-below-img" 
            src={Twitter} 
            alt="" 
            /> 
            <a 
            href="https://www.linkedin.com/in/rahul-gautam-66951922/" 
            target="_blank" 
            rel="noopener noreferrer" 
            > 
            <img 
            style={{ marginLeft: "20px" }} 
            className="Footer-below-img" 
            src={Linkedin} alt="" 
            /> 
            </a> 
             <a
          href="https://www.google.com/maps/place/Purohit+Technosoft/@26.9383394,75.7585727,17z/data=!3m1!4b1!4m6!3m5!1s0x396db38f968de17f:0x8546cbe3cf5085af!8m2!3d26.9383346!4d75.7611476!16s%2Fg%2F11rvdbyvyf?entry=ttu&g_ep=EgoyMDI1MDkxMC4wIKXMDSoASAFQAw%3D%3D"
          target="_blank"
          rel="noopener noreferrer"
        >
            <img 
            style={{ marginLeft: "20px" }} 
            className="Footer-below-img" src={Google} 
            alt="" 
            />
            </a> 
            </div> 
            </div> 
            </div> 
            );
           } 
           export default Footer;